import React, { useState } from 'react';

interface StreamSidebarSectionProps {
  title: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
}

const SECTION_TITLE_STYLE: React.CSSProperties = {
  fontSize: '0.65rem',
  textTransform: 'uppercase',
  letterSpacing: '0.07em',
};

export const StreamSidebarSection: React.FC<StreamSidebarSectionProps> = ({
  title,
  children,
  defaultExpanded = true,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <section className="border-bottom">
      <button
        type="button"
        className="w-100 d-flex align-items-center justify-content-between px-3 py-2 border-0 bg-transparent text-start"
        onClick={() => setIsExpanded((current) => !current)}
        aria-expanded={isExpanded}
        title={isExpanded ? `Collapse ${title}` : `Expand ${title}`}
      >
        <span className="text-muted fw-semibold" style={SECTION_TITLE_STYLE}>
          {title}
        </span>
        <i
          className={`fas ${isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'} text-muted`}
          aria-hidden="true"
          style={{ fontSize: '0.7rem' }}
        />
      </button>
      {isExpanded && <div className="px-3 pb-3 d-flex flex-column gap-3">{children}</div>}
    </section>
  );
};
